import React from "react";
import { ShieldCheck, BadgeCheck, EyeOff, FileLock2, Film, Lock } from "lucide-react";
import Reveal from "./Reveal";
import { useT } from "./i18n";

const ICONS = [BadgeCheck, ShieldCheck, EyeOff, FileLock2, Film, Lock];

export default function TrustPrivacy() {
  const { t } = useT();
  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#C4A46B]">{t.trust.eyebrow}</p>
          <h2 className="mt-3 max-w-2xl font-serif text-4xl leading-tight text-[#173A2C] sm:text-5xl">{t.trust.heading}</h2>
          <p className="mt-3 max-w-2xl text-base text-[#5C5855]">{t.trust.sub}</p>
        </Reveal>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {t.trust.items.map(([title, desc], i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={title} delay={(i % 3) + 1} className="rounded-2xl border border-[#E8E4DB] bg-[#FDFBF7] p-6">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#1F4A38]/8 text-[#1F4A38]"><Icon className="h-5 w-5" /></span>
                <h3 className="mt-4 text-base font-semibold text-[#173A2C]">{title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-[#5C5855]">{desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
